import {Link, useNavigate} from 'react-router-dom';
import {FaSignInAlt, FaUser} from 'react-icons/fa';
import useAuthHook from '../../api/auth';
import useAuth from '../../hooks/useAuth';
import LanguageSwitcher from "./LanguageSwitcher";
import useUserCategoriesHook from '../../api/userCategories';
import {useMutation} from 'react-query';
import {useTranslation} from 'react-i18next';
import React from "react";
import NotificationBell from '../admin/notifications/NotificationBell';
const Navigation = () => {
    const navigate = useNavigate();
    const {postLogout} = useAuthHook();
    const {auth, setAuth} = useAuth();
    const {t} = useTranslation();

    // Use the user categories hook to fetch categories
    const {getGuestCategories, getAdminCategories} = useUserCategoriesHook({});

    // Fetch appropriate categories based on auth state
    const {data: categoriesData, isLoading} = auth?.userInfo
        ? getAdminCategories
        : getGuestCategories;

    const {mutateAsync: logout} = useMutation(postLogout, {
        onSuccess: () => {
            setAuth(null);
            navigate('/admin/login');
        },
    });

    const handleLogout = () => {
        logout({});
    };

    const user = () => {
        return auth?.userInfo;
    };

    const organizeMenus = () => {
        const categories = categoriesData?.categories || [];

        // Safely map categories, ensuring each item has a menu property
        const dropdownItems = categories.map((category) => category.menu || '');
        const uniqueDropdowns = [...new Set(dropdownItems.filter(item => item && item !== 'hidden' && item !== 'normal'))];

        // Separate profile item
        const profileDropdown = uniqueDropdowns.find(item => item === 'account');
        const otherDropdowns = uniqueDropdowns.filter(item => item !== 'account');

        // Organize other dropdowns and append profile at the end
        const sortedDropdowns = [...otherDropdowns, profileDropdown];

        const menuItems = categories.map((category) => category);

        return {sortedDropdowns, menuItems};
    };

    const renderAuthItems = () => {
        const {sortedDropdowns, menuItems} = organizeMenus();

        return (
            <nav className='navbar navbar-expand-md navbar-light bg-light'>
                <div className='container'>
                    <Link to='/'>
                        <img
                            width='40'
                            height='40'
                            src='/img/communitism_logo_transparent_black.png'
                            className='img-fluid brand-logos'
                            alt='logo'
                        />
                    </Link>
                    <button
                        className='navbar-toggler'
                        type='button'
                        data-bs-toggle='collapse'
                        data-bs-target='#navbarNav'
                        aria-controls='navbarNav'
                        aria-expanded='false'
                        aria-label='Toggle navigation'
                    >
                        <span className='navbar-toggler-icon'></span>
                    </button>
                    <div className='collapse navbar-collapse' id='navbarNav'>
                        <ul className='navbar-nav ms-auto'>
                            {menuItems.map((menu, index) => {
                                if (menu.menu === 'normal' && menu.auth === true) {
                                    return (
                                        <li key={menu._id || `menu-item-${index}`} className='nav-item'>
                                            <Link to={menu.path} className='nav-link' aria-current='page'>
                                                {t(menu.name)}
                                            </Link>
                                        </li>
                                    );
                                } else {
                                    return null;
                                }
                            })}

                            {sortedDropdowns.map((item, index) => (
                                item && (
                                    <li key={`${item}-${index}`} className='nav-item dropdown'>
                                        <a
                                            className='nav-link dropdown-toggle'
                                            id='navbarDropdownMenuLink'
                                            role='button'
                                            data-bs-toggle='dropdown'
                                            aria-expanded='false'
                                        >
                                            {item === 'account' ? (
                                                <>
                                                    <FaUser
                                                        className='me-1 menu-navigation-icon navigation-profile-icon'/>
                                                    {user()?.name}
                                                </>
                                            ) : (
                                                t(item.charAt(0).toUpperCase() + item.substring(1))
                                            )}
                                        </a>
                                        <ul className='dropdown-menu border-0' aria-labelledby='navbarDropdownMenuLink'>
                                            {menuItems.map((menu) => {
                                                if (menu.menu === item) {
                                                    return (
                                                        <li key={menu._id}>
                                                            <Link to={menu.path} className='dropdown-item'>
                                                                {t(menu.name)}
                                                            </Link>
                                                        </li>
                                                    );
                                                } else {
                                                    return null;
                                                }
                                            })}
                                            {item === 'account' && (
                                                <li key={`profile-logout-${index}`}>
                                                    <Link
                                                        to='/admin/login'
                                                        className='dropdown-item logout-menu-item'
                                                        onClick={handleLogout}
                                                    >
                                                        {t("Logout")}
                                                    </Link>
                                                </li>
                                            )}
                                        </ul>
                                    </li>
                                )
                            ))}
                            <li className="nav-item d-flex align-items-center me-2">
                                <NotificationBell/>
                            </li>
                        </ul>
                    </div>
                    {<LanguageSwitcher/>}
                </div>
            </nav>
        );
    };

    const renderGuestItems = () => (
        <nav className='navbar navbar-light guest-navbar'>
            <div className='container'>
                {/*<Link to='/'>*/}
                {/*    <img*/}
                {/*        width='80'*/}
                {/*        height='80'*/}
                {/*        src='/img/communitism_logo_transparent_black.png'*/}
                {/*        className='img-fluid brand-logos'*/}
                {/*        alt='logo'*/}
                {/*    />*/}
                {/*</Link>*/}
                <button
                    className='navbar-toggler'
                    type='button'
                    data-bs-toggle='collapse'
                    data-bs-target='#navbarNav'
                    aria-controls='navbarNav'
                    aria-expanded='false'
                    aria-label='Toggle navigation'
                >
                    <span className='navbar-toggler-icon'></span>
                    <div className='navbar-toggler-text'>{t("MENU")}</div>
                </button>
                <div className='collapse navbar-collapse guest-item-spaces' id='navbarNav'>
                    <button
                        type='button'
                        className='btn-close ms-auto'
                        aria-label='Close'
                        data-bs-toggle='collapse'
                        data-bs-target='#navbarNav'
                    ></button>
                    <Link to='/spaces' className='nav-link-to-spaces maps-link-text'>{t("Metaxourgeio Map")}</Link>
                    <Link to='/about' className='nav-link-to-spaces'>{t("About")}</Link>
                    <a href='https://communitism.space' target='_blank' rel='noopener noreferrer'
                       className='nav-link-to-spaces'>
                        {t("Home")}
                    </a>
                    <Link to='/participate' className='nav-link-to-spaces'>{t("Participate")}</Link>
                    <Link to='/privacy' className='nav-link-to-spaces'>{t("Privacy")}</Link>
                    <Link to='/contact' className='nav-link-to-spaces'>{t("Contact")}</Link>
                    {/*<img*/}
                    {/*    width='80'*/}
                    {/*    height='80'*/}
                    {/*    src='/img/communitism_logo_transparent_black.png'*/}
                    {/*    className='img-fluid brand-logos'*/}
                    {/*    alt='logo'*/}
                    {/*/>*/}
                    <div className='navbar-nav-signin'>
                        <Link to='/admin/login' className='nav-link-to-spaces' aria-current='page'>
                            <FaSignInAlt className='mb-1'/> {t("Login")}
                        </Link>
                    </div>
                </div>
            </div>
        </nav>
    );

    if (isLoading) {
        return <div>Loading...</div>; // Loading state while fetching categories
    }

    // // Handle error state specifically for 401 Unauthorized
    // if (isError) {
    //     if (error?.status === 401) {
    //         return (
    //             <div>
    //                 {renderGuestItems()}
    //             </div>
    //         );
    //     }
    //     return <div>Error loading categories</div>;
    // }

    return (
        auth?.userInfo ? renderAuthItems() : renderGuestItems()
    )
};

export default Navigation;
